import { Subscription } from 'rxjs';
import { Message, MessageReplyTo } from '../chat-message/chat-message.interface';
import {
  ATTACHMENTS_TYPES,
  CHAT_EXTERNAL_TYPE,
  MESSAGE_TYPES,
  MessageSocketAction,
  SEND_ACTION_TYPE,
} from '../../../../../enum/constants';
import { PlannerItem } from '../../../stacked-sidebar/components/planner-v2/planner-v2.interface';
import { VoiceFormat } from '../../../../../services/voice-recording.service';

export interface IUserInfo {
  id: string;
  user_ads_url: string;
  name: string;
  person?: string;
}

export interface IInitMessagesParams {
  direction?: 'up' | 'down' | 'center';
  pagination?: boolean;
  event?: any;
  message_id?: string;
  scroll_params?: ScrollParams;
}

export interface IChatMessagesInfo {
  items: Message[];
  grouped_items: TGroupItem[];
  total_first?: string;
  total_last?: string;
  items_request?: Subscription;
}

export enum MESSAGES_INFO_POSITION {
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export interface IChatSearchInfo {
  items: Message[] | null;
  loading: boolean;
  search_text: string;
  search_visible: boolean;
  page_number: number;
  page_count: number;
  selected_number?: number;
  items_request?: Subscription;
}

export interface IChatAdditionalInfo {
  items: Message[];
  grouped_items: TGroupItem[];
  visible: boolean;
  items_request?: Subscription;
}

export interface TGroupItem {
  messages: Message[];
  date: string;
}

export interface IMenuButton {
  title: string;
  icon: string;
  action: () => void;
  divider?: boolean;
  is_svg?: boolean;
  key?: string;
  disabled?: () => boolean;
}

export enum TABS {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  SPAM = 'SPAM',
}

export interface IRiaAdvert {
  id: number;
  title: string;
  url: string;
  price: string;
  auction: number;
  exchange: number;
  owner_id: number;
  price_eur: string;
  price_usd: string;
  empty_data: boolean;
  is_deleted: boolean;
  main_photo_url: string;
  short_info: string;
}

export interface ITempMessagePayload {
  temp_id: string,
  chat_id: string,
  type_message: MESSAGE_TYPES,
  text: string,
  attachments?: any,
  x_data?: any,
}

export interface UploadAttachments {
  type: ATTACHMENTS_TYPES;
  url: string;
  key?: string;
  formattedType: string;
  mimeType: string;
  name: string;
  size: number;
  voice?: boolean;
}

export interface ScrollParams {
  behavior?: ScrollBehavior,
  is_highlighted?: boolean;
}

export interface TMessageAction {
  action: SEND_ACTION_TYPE;
  actionText: string | '';
  actionXData: TMessageActionXData;
  isMyActionMessage: boolean;
}

export interface TMessageActionXData {
  ria_type_mes?: number;
  ria_previous_message_id?: number;
  message_id?: string;
  reply_to?: MessageReplyTo;
  delayed?: PlannerItem;
  x_data?: any;
  tiktok?: {
    comment_id?: string;
    video_id?: string;
  };
  //add edit and other
}

export interface ISendMessageBody {
  text: string;
  text_message?: string;
  send_action: SEND_ACTION_TYPE;
  attachments?: Record<string, any>;
  x_data?: TMessageActionXData;
}

export interface TMessageUpdatedSocket {
  action: MessageSocketAction;
  company_id: string;
  chat_id: string;
  message_id?: string;
  x_data?: any;
}

export const RIA_CHAT_TYPES: CHAT_EXTERNAL_TYPE[] = [
  CHAT_EXTERNAL_TYPE.AGRO_RIA,
  CHAT_EXTERNAL_TYPE.DOM_RIA,
  CHAT_EXTERNAL_TYPE.AUTO_RIA,
  CHAT_EXTERNAL_TYPE.RIA,
];

export const OLD_RIA_CHAT_TYPES: CHAT_EXTERNAL_TYPE[] = [
  CHAT_EXTERNAL_TYPE.RIA_WH,
  CHAT_EXTERNAL_TYPE.DOM_RIA_WH,
  CHAT_EXTERNAL_TYPE.AUTO_RIA_WH,
  CHAT_EXTERNAL_TYPE.AGRO_RIA_WH,
];

export const UPLOAD_FILES_DISABLED_CHAT_TYPES = [
  ...RIA_CHAT_TYPES,
  CHAT_EXTERNAL_TYPE.TELEGRAM_BOT,
];

export const UPLOAD_FILES_DISABLED_SEND_ACTIONS = [
  SEND_ACTION_TYPE.REPLY_COMMENT,
  SEND_ACTION_TYPE.SEND_MESSAGE_BY_COMMENT_TO_DIRECT,
];

export const VOICE_MESSAGE_CHAT_TYPES = [
  CHAT_EXTERNAL_TYPE.TELEGRAM_USER,
  CHAT_EXTERNAL_TYPE.INSTAGRAM,
];

export const FORMAT_BY_CHAT_TYPE = {
  [CHAT_EXTERNAL_TYPE.TELEGRAM_USER]: VoiceFormat.OGG,
  [CHAT_EXTERNAL_TYPE.INSTAGRAM]: VoiceFormat.WAV,
} as Record<CHAT_EXTERNAL_TYPE, VoiceFormat>;
